import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Footer } from '../Layout'
import { YenSpan } from '../common/YenSpan'

class ConfirmBar extends React.PureComponent {
  static defaultProps = {
    value: 0,
    onSubmit: function () {}
  }
  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    invalid: PropTypes.bool,
    onSubmit: PropTypes.func
  }

  render () {
    const {
      extra,
      value,
      invalid,
      onSubmit
    } = this.props
    return <Footer className={'justify-between'}>
      <div className={'pl-4'}>
        <span>支付金额（约）&emsp;</span>
        <YenSpan className={'text-red-500'}>{value}</YenSpan>
        <div>{extra}</div>
      </div>
      <div className={classnames('confirm-bar__button', { 'confirm-bar__button--invalid': invalid })}
        onClick={onSubmit}>立即购买
      </div>
    </Footer>
  }
}

export { ConfirmBar }
